<template>
    <div>
        <div class="RDSMonitor-title">
            <div>{{ $t('alarms.database.database') }}</div>
            <div>
                <Button type="primary" @click="addOrUpdateHandle" v-hasPermission="['monitor:relationalDatabaseServiceMonitor:add_alert_rule']">{{ $t('alarms.database.addDatabaseAlarm') }}</Button>
                <Button v-if="currentTab === 'tabAlertRule'" type="warning" @click="exportAlertRuleList">导出数据库报警规则</Button>
                <add-or-update-relational-database-service-warning v-if="addOrUpdateVisible" ref="addOrUpdate"></add-or-update-relational-database-service-warning>
            </div>
        </div>
        <template>
            <Tabs size="small" v-model="currentTab" :animated="false">
                <TabPane :label="$t('alarms.database.databaseList')" name="tabDatabase">
                    <table-relational-database-service @changeCurrentTab="changeCurrentTab"></table-relational-database-service>
                </TabPane>
                <TabPane :label="$t('alarms.common.alertRule')" name="tabAlertRule">
                    <div class="RDSMonitor-top">
                      <relational-database-service-warning-alert-rule-search ref="ruleSearch"></relational-database-service-warning-alert-rule-search>
                    </div>
                    <table-relational-database-service-warning></table-relational-database-service-warning>
                </TabPane>
            </Tabs>
        </template>

    </div>
</template>

<script>
    import TableRelationalDatabaseService from '../rds/TableRelationalDatabaseService';
    import AddOrUpdateRelationalDatabaseServiceWarning from '../rds/AddOrUpdateRelationalDatabaseServiceWarning';
    import RelationalDatabaseServiceWarningAlertRuleSearch from "./RelationalDatabaseServiceWarningAlertRuleSearch";
    import TableRelationalDatabaseServiceWarning from "./TableRelationalDatabaseServiceWarning";
    import {getCookie} from "../../../utils/cookieUtil";
    const tableRelationalDatabaseServiceWarning = TableRelationalDatabaseServiceWarning;
    export default {
        name: 'RelationalDatabaseServiceMonitor',
        components: {
            TableRelationalDatabaseService,
            AddOrUpdateRelationalDatabaseServiceWarning,
            RelationalDatabaseServiceWarningAlertRuleSearch,
            TableRelationalDatabaseServiceWarning
        },
        data(){
            return {
                currentTab:'',
                addOrUpdateVisible:false
            }
        },
        methods:{
            // 添加报警规则
            /**********************************************************************************/
            addOrUpdateHandle:function(){
                this.addOrUpdateVisible=true;
                this.$nextTick(() => {
                    this.$refs.addOrUpdate.init()
                })
            },
            changeCurrentTab:function(row,monitorIndex){
              this.currentTab = 'tabAlertRule';
              eventBus.$emit('databaseId', row.databaseId);
              eventBus.$emit('monitorIndex', monitorIndex);
              eventBus.$emit('typeId', 1);
              // eventBus.$emit('stateId', 0);
              tableRelationalDatabaseServiceWarning.methods.showAll();
            },
          /***********************导出*****************************/
          exportAlertRuleList: function () {
            this.$Message.loading({
              duration: 0,
              content: '正在导出，请稍等...'
            })
            // 下载Excel 文件
            this.$api.alertRule.exportResourceAlertRule({
              companyId: !this.$refs.ruleSearch.companyId ? getCookie(global.companyId) : this.$refs.ruleSearch.companyId,
              monitorModule: 1,
              accountId: this.$refs.ruleSearch.accountId,
              stateId: this.$refs.ruleSearch.stateId,
              typeId: this.$refs.ruleSearch.typeId,
              delayTypeId: this.$refs.ruleSearch.delayTypeId
            })
              .then(res => {
                let fileName = 'resourceAlertRule.xls'
                let blob = new Blob([res.data], {type: 'application/x-xls'})
                if (window.navigator.msSaveOrOpenBlob) {
                  navigator.msSaveBlob(blob, fileName);
                }else{
                  var link = document.createElement('a');
                  link.href = window.URL.createObjectURL(blob);
                  link.download = fileName;
                  link.click();
                  window.URL.revokeObjectURL(link.href);
                }
                this.$Message.success('导出成功');
              })
              .finally(() => {
                this.$Message.destroy();
              })
          }
        }
    }
</script>

<style scoped>
    .RDSMonitor-title
    {
        width: 100%;
        font-size: 13px;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        padding: 15px 0px 0px 4px;
        font-weight: 600;
        overflow: hidden;
    }
    .RDSMonitor-title>div:nth-child(1)
    {
        float:left;
    }
    .RDSMonitor-title>div:nth-child(2)
    {
        float:right;
        margin-top: -6px;
    }
</style>



// WEBPACK FOOTER //
// src/components/monitor/rds/RelationalDatabaseServiceMonitor.vue